export const TRAVEL_INSURANCE_DETAILS_FORM = 'travelKe/travelDetailsForm/';

export const TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE = TRAVEL_INSURANCE_DETAILS_FORM + 'setValue/';
export const TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID = TRAVEL_INSURANCE_DETAILS_FORM + 'setValid/';

export const FORM_VALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM = 'travelKe/travelDetailsForm/transition/formValid';
export const FORM_INVALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM = 'travelKe/travelDetailsForm/transition/formInValid';

export const REINITIALIZE = 'travelKe/travelDetailsForm/state/reinitialize';
export const POPULATE_FORM = 'travelKe/travelDetailsForm/state/populate';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_TRAVEL_DETAILS_FORM = 'travelKe/travelDetailsForm/transition/dropOffLead';
export const dropOffLeadPersonalDetails = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_TRAVEL_DETAILS_FORM,
    value,
});

export const transitionTravelInsuranceTravelDetailsForm = {
    formValid: () => ({
        type: FORM_VALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM,
    }),
};

// API Calls actions
export const API_INITIAL_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/initial`;
export const API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/failure`;

export const apiTransitionPersonalDetailsForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
};

//calculated Data
export const COLLECT_TRAVEL_DETAILS_FORM_DATA =
    TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'collectPersonalDetailsData';
export const SUBMIT_TRAVEL_DETAILS_SUCCESS = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'success';
export const SUBMIT_TRAVEL_DETAILS_FAILURE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'failure';

export const collectPersonalDetailsData = () => ({
    type: COLLECT_TRAVEL_DETAILS_FORM_DATA,
});
export const submitPersonalDetailsDataSuccess = (value) => ({
    type: SUBMIT_TRAVEL_DETAILS_SUCCESS,
    value,
});
export const submitPersonalDetailsFailure = (error) => ({
    type: SUBMIT_TRAVEL_DETAILS_FAILURE,
    error,
});

export const PERSONAL_DETAILS_ID_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'personalDetailsId';
export const PERSONAL_DETAILS_ID_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'personalDetailsId';

// Form Values
export const TITLE_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'title';
export const TITLE_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'title';

export const FULL_NAME_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'fullName';
export const FULL_NAME_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'fullName';

export const DOB_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'DOB';
export const DOB_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'DOB';

export const AGE_BAND_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'ageBand';
export const AGE_BAND_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'ageBand';

export const ID_TYPE_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'idType';
export const ID_TYPE_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'idType';

export const ID_NUMBER_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'idNumber';
export const ID_NUMBER_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'idNumber';

export const PASSPORT_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'passport';
export const PASSPORT_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'passport';

export const KRA_NUMBER_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'kraNumber';
export const KRA_NUMBER_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'kraNumber';

export const PHONE_NUMBER_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'phoneNumber';
export const PHONE_NUMBER_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'phoneNumber';

export const EMAIL_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'email';

export const KRA_PIN_DOC_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'kraPinDoc';
export const KRA_PIN_DOC_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'kraPinDoc';
export const KRA_PIN_RESET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'reset/kraPinDoc';

export const ID_DOC_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'idDoc';
export const ID_DOC_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'idDoc';
export const ID_DOC_RESET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'reset/idDoc';

export const PASSPORT_DOC_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'passportDoc';
export const PASSPORT_DOC_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'passportDoc';
export const PASSPORT_DOC_RESET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'reset/passportDoc';

export const SET_TRAVELLERS_ID_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'travellersId';

export const TRAVELLERS_SET_VALUE = TRAVEL_INSURANCE_DETAILS_FORM + 'travellers';

export const TRAVELLER_SET_VALUE = TRAVEL_INSURANCE_DETAILS_FORM + 'traveller';
export const UPDATE_TRAVELLER_VALUE = TRAVEL_INSURANCE_DETAILS_FORM + 'updateTraveller';

export const SET_CURRENT_TRAVELLER_INDEX = TRAVEL_INSURANCE_DETAILS_FORM + 'currentTraveller';

export const FULL_NAME_EMERGENCY_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'fullNameEmergency';
export const FULL_NAME_EMERGENCY_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'fullNameEmergency';

export const PHONE_NUMBER_EMERGENCY_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'phoneNumberEmergency';
export const PHONE_NUMBER_EMERGENCY_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'phoneNumberEmergency';

export const EMAIL_EMERGENCY_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'emailEmergency';
export const EMAIL_EMERGENCY_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'emailEmergency';

export const REFERRED_SET_VALUE = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE + 'referred';
export const REFERRED_SET_VALID = TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID + 'referred';

// action creators

export const setReferredValue = (value) => ({
    type: REFERRED_SET_VALUE,
    value,
});

export const setReferredValid = (error) => ({
    type: REFERRED_SET_VALID,
    error,
});

export const setTitleValue = (value) => ({
    type: TITLE_SET_VALUE,
    value,
});

export const setTitleValid = (error) => ({
    type: TITLE_SET_VALID,
    error,
});

export const setFullNameValue = (value) => ({
    type: FULL_NAME_SET_VALUE,
    value,
});

export const setFullNameValid = (error) => ({
    type: FULL_NAME_SET_VALID,
    error,
});

export const setIdNumberValue = (value) => ({
    type: ID_NUMBER_SET_VALUE,
    value,
});

export const setIdNumberValid = (error) => ({
    type: ID_NUMBER_SET_VALID,
    error,
});

export const setPassportValue = (value) => ({
    type: PASSPORT_SET_VALUE,
    value,
});

export const setPassportValid = (error) => ({
    type: PASSPORT_SET_VALID,
    error,
});

export const setKraNumberValue = (value) => ({
    type: KRA_NUMBER_SET_VALUE,
    value,
});

export const setKraNumberValid = (error) => ({
    type: KRA_NUMBER_SET_VALID,
    error,
});

export const setPhoneNumberValue = (value) => ({
    type: PHONE_NUMBER_SET_VALUE,
    value,
});
export const setPhoneNumberValid = (error) => ({
    type: PHONE_NUMBER_SET_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});
export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setDOBValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});
export const setDOBValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setAgeBandValue = (value) => ({
    type: AGE_BAND_SET_VALUE,
    value,
});

export const setAgeBandValid = (error) => ({
    type: AGE_BAND_SET_VALID,
    error,
});

export const setKraPinValue = (value) => ({
    type: KRA_PIN_DOC_SET_VALUE,
    value,
});
export const setKraPinValid = (error) => ({
    type: KRA_PIN_DOC_SET_VALID,
    error,
});
export const resetKraPinValue = () => ({
    type: KRA_PIN_RESET_VALUE,
});

export const setIdDocValue = (value) => ({
    type: ID_DOC_SET_VALUE,
    value,
});
export const setIdDocValid = (error) => ({
    type: ID_DOC_SET_VALID,
    error,
});
export const resetIdDocValue = () => ({
    type: ID_DOC_RESET_VALUE,
});

export const setPassportDocValue = (value) => ({
    type: PASSPORT_DOC_SET_VALUE,
    value,
});
export const setPassportDocValid = (error) => ({
    type: PASSPORT_DOC_SET_VALID,
    error,
});
export const resetPassportDocValue = () => ({
    type: PASSPORT_DOC_RESET_VALUE,
});

export const setTravellersValue = (value) => ({
    type: TRAVELLERS_SET_VALUE,
    value,
});

export const setTravellerValue = (value) => ({
    type: TRAVELLER_SET_VALUE,
    value,
});

export const updateTravellerValue = (value, id) => ({
    type: UPDATE_TRAVELLER_VALUE,
    value,
    id,
});

export const setIdTypeValue = (value) => ({
    type: ID_TYPE_SET_VALUE,
    value,
});

export const setIdTypeValid = (error) => ({
    type: ID_TYPE_SET_VALID,
    error,
});

export const setCurrentTraller = (value) => ({
    type: SET_CURRENT_TRAVELLER_INDEX,
    value,
});

export const setTravellerIdValue = (value) => ({
    type: SET_TRAVELLERS_ID_VALUE,
    value,
});

export const formReinitialize = () => ({
    type: REINITIALIZE,
});

export const populateForm = (value) => ({
    type: POPULATE_FORM,
    value,
});

export const setFullNameEmergencyValue = (value) => ({
    type: FULL_NAME_EMERGENCY_SET_VALUE,
    value,
});

export const setFullNameEmergencyValid = (error) => ({
    type: FULL_NAME_EMERGENCY_SET_VALID,
    error,
});
export const setPhoneNumberEmergencyValue = (value) => ({
    type: PHONE_NUMBER_EMERGENCY_SET_VALUE,
    value,
});
export const setPhoneNumberEmergencyValid = (error) => ({
    type: PHONE_NUMBER_EMERGENCY_SET_VALID,
    error,
});
export const setEmailEmergencyValue = (value) => ({
    type: EMAIL_EMERGENCY_SET_VALUE,
    value,
});
export const setEmailEmergencyValid = (error) => ({
    type: EMAIL_EMERGENCY_SET_VALID,
    error,
});

export const setPersonalDetailIdValue = (value) => ({
    type: PERSONAL_DETAILS_ID_SET_VALUE,
    value,
});

export const setPersonalDetailIdValid = (error) => ({
    type: PERSONAL_DETAILS_ID_SET_VALID,
    error,
});
